function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "book");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 5.95v10.351c0 0.522-0.452 0.771-1 1.16-0.44 0.313-1-0.075-1-0.587 0 0 0-9.905 0-10.114 0-0.211-0.074-0.412-0.314-0.535s-7.738-4.065-7.738-4.065c-0.121-0.045-0.649-0.378-1.353-0.016-0.669 0.344-1.033 0.718-1.126 0.894l8.18 4.482c0.217 0.114 0.351 0.29 0.351 0.516v10.802c0 0.23-0.142 0.476-0.369 0.585-0.104 0.052-0.219 0.077-0.333 0.077-0.135 0-0.271-0.033-0.386-0.104-0.215-0.131-7.774-4.766-8.273-5.067-0.24-0.144-0.521-0.439-0.527-0.658l-0.112-10.286c0-0.198-0.023-0.547 0.289-1.032 0.697-1.084 3.129-2.317 4.36-1.678l8.999 4.555c0.217 0.112 0.352 0.336 0.352 0.72z"
});

var SvgBook = function SvgBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/book.e860d225.svg";
export { ForwardRef as ReactComponent };